import { render, staticRenderFns } from "./ground_ordered_delete.vue?vue&type=template&id=01d4587c&"
import script from "./ground_ordered_delete.vue?vue&type=script&lang=ts&"
export * from "./ground_ordered_delete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports